import {
    CCP_GET_FEATURE_SWITCH_DESCRIPTIONS,
    CCP_GET_FEATURE_SWITCHES_GLOBAL,
    CCP_SET_GLOBAL_FEATURE_SWITCHES,
    CCP_SET_WHITELABELS,
    CCP_WHITELABELS_LIST
} from '../endpoints'
import request from '../request'

export const getFeatureSwitchesDescription = () => {
    return request.get(CCP_GET_FEATURE_SWITCH_DESCRIPTIONS)
}

export const getFeatureSwitchesGlobal = () => {
    return request.get(CCP_GET_FEATURE_SWITCHES_GLOBAL)
}

export const getWhiteLabelsList = () => {
    return request.get(CCP_WHITELABELS_LIST)
}

export const setWhiteLabels = (payload) => {
    return request.post(CCP_SET_WHITELABELS, payload)
}

export const setGlobalFeatureSwitches = (payload) => {
    return request.post(CCP_SET_GLOBAL_FEATURE_SWITCHES, payload)
}

